export const messages = {
  en: {
    chainSupplier: {
      addSupplier: 'Add Supplier',
      editSupplier: 'Edit Supplier',
      supplierName: 'Supplier Name',
      supplierNamePlaceholder: 'Please enter supplier name',
      supplierNameRequired: 'Supplier name is required',
      supplierNameMaxLength: 'Supplier name cannot exceed 30 characters',
      appId: 'App ID',
      appIdPlaceholder: 'Please enter app ID',
      appIdRequired: 'App ID is required',
      appIdMaxLength: 'App ID cannot exceed 500 characters',
      appSecure: 'App Secure',
      appSecurePlaceholder: 'Please enter app secure',
      appSecureRequired: 'App secure is required',
      appSecureMaxLength: 'App secure cannot exceed 500 characters',
      mchId: 'Merchant ID',
      mchIdPlaceholder: 'Please enter merchant ID',
      mchIdRequired: 'Merchant ID is required',
      mchIdMaxLength: 'Merchant ID cannot exceed 32 characters',
      mchKey: 'Merchant Key',
      mchKeyPlaceholder: 'Please enter merchant key',
      mchKeyRequired: 'Merchant key is required',
      mchKeyMaxLength: 'Merchant key cannot exceed 128 characters',
      url: 'URL',
      urlPlaceholder: 'Please enter URL',
      urlRequired: 'URL is required',
      urlMaxLength: 'URL cannot exceed 128 characters',
      beanName: 'Bean Name',
      beanNamePlaceholder: 'Please enter bean name',
      beanNameRequired: 'Bean name is required',
      beanNameMaxLength: 'Bean name cannot exceed 50 characters',
      suType: 'Supplier Type',
      suType1: 'Self-built chain (products can be modified)',
      suType2: 'Mature chain (read only)',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      confirmDeleteSupplier: 'Are you sure to delete this supplier?',
      supplierIdRequired: 'Supplier ID is required'
    }
  },
  zh: {
    chainSupplier: {
      addSupplier: '添加供应商',
      editSupplier: '修改供应商',
      supplierName: '供应商名称',
      supplierNamePlaceholder: '请输入供应商名称',
      supplierNameRequired: '供应商名称不能为空',
      supplierNameMaxLength: '供应商名称不能超过30个字符',
      appId: '接口应用ID',
      appIdPlaceholder: '请输入接口应用ID',
      appIdRequired: '接口应用ID不能为空',
      appIdMaxLength: '接口应用ID不能超过500个字符',
      appSecure: '接口秘钥',
      appSecurePlaceholder: '请输入接口秘钥',
      appSecureRequired: '接口秘钥不能为空',
      appSecureMaxLength: '接口秘钥不能超过500个字符',
      mchId: '商户ID',
      mchIdPlaceholder: '请输入商户ID',
      mchIdRequired: '商户ID不能为空',
      mchIdMaxLength: '商户ID不能超过32个字符',
      mchKey: '秘钥',
      mchKeyPlaceholder: '请输入秘钥',
      mchKeyRequired: '秘钥不能为空',
      mchKeyMaxLength: '秘钥不能超过128个字符',
      url: '接口地址',
      urlPlaceholder: '请输入接口地址',
      urlRequired: '接口地址不能为空',
      urlMaxLength: '接口地址不能超过128个字符',
      beanName: '适配器名称',
      beanNamePlaceholder: '请输入适配器名称',
      beanNameRequired: '适配器名称不能为空',
      beanNameMaxLength: '适配器名称不能超过50个字符',
      suType: '供应链类型',
      suType1: '自建链（商品可删除修改)',
      suType2: '成熟链（不可编辑）',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      confirmDeleteSupplier: '确定删除供应商吗？',
      supplierIdRequired: '供应商ID不能为空'
    }
  }
}